<template>
  <v-dialog
    :value="visiblePopup"
    :width="1100"
    style='height: 500px; min-width: 700px'
    @click:outside="closeClicked"
    @keydown.esc="closeClicked"
  >
      <v-card class="popup-wrapper">
        <div class='workflow' id='workflow'>
          <div class='workflow__header'>
            <div class='add-workflow-title'> {{ $t('add.work.flow.title') }} </div>
            <span class='close-button' @click='closeClicked'>
              <span class="material-icons-outlined">
                close
              </span>
            </span>
          </div>
          <div class='workflow__content'>
            <span class='field-label'>
              {{ $t('work.flow.name.label') }}
            </span>
            <v-text-field
              v-model='workflowName'
              dense
              outlined
            />
            <span class='field-label'>
              {{ $t('work.flow.description.label') }}
            </span>
            <v-textarea
              v-model='workflowDescription'
              class="input-description input-textarea"
              outlined
            />
            <v-divider class='divider' />
            <span class='field-label'>
              {{ $t('work.flow.editor.label') }}
            </span>
            <div class='flow-chart-section'>
              <work-flow-graph-editor ref='flowChart' :workflow='workflow'/>
            </div>
            <div class='actions'>
              <v-btn small depressed class="cancel-button" @click="closeClicked"> {{ $t('confirm.cancel') }} </v-btn>
              <v-btn class="save-button" text @click="saveClicked" dense x-small>{{ $t('save') }}</v-btn>
            </div>
          </div>
        </div>
      </v-card>
  </v-dialog>
</template>

<script>
import WorkFlowGraphEditor from '@/components/workflows/WorkFlowGraphEditor.vue';
import disableOuterScrollOnPopupVisible from '@/mixins/disableOuterScrollOnPopupVisible';

export default {
  name: 'WorkFlowGraphEditorPopup',
  mixins: [disableOuterScrollOnPopupVisible],
  components: { WorkFlowGraphEditor },
  props: {
    visiblePopup: {
      required: true,
    },
  },
  data() {
    return {
      workflow: {},
      workflowName: '',
      workflowDescription: '',
    };
  },
  watch: {
    visiblePopup(newVal) {
      if (newVal) {
        this.$forceUpdate();
      }
    },
  },
  methods: {
    closeClicked() {
      this.workflow = {};
      this.workflowName = '';
      this.workflowDescription = '';
      // eslint-disable-next-line no-unused-expressions
      this.$refs.flowChart?.$children?.[0]?.propsAPI?.read(this.workflow);
      this.$emit('closed');
    },
    saveClicked() {
      this.workflow = this.saveDataFromChart();
      this.$emit('saveWorkflow', {
        data: this.workflow,
        name: this.workflowName,
        description: this.workflowDescription,
      });
    },
    saveDataFromChart() {
      return this.$refs.flowChart?.$children?.[0]?.propsAPI?.save() || {};
    },
  },
};
</script>

<style lang='scss'>
@import "~@/assets/styles/design-system";
.popup-wrapper {
  background-color: var(--bg-primary) !important;
  &.workflow .close-button {
    .v-btn__content {
      color: #8E30D0 !important;
    }
  }
}
.flow-chart-section {
  .work-flow-graph .graph__container {
    border-left: solid 1px var(--border-primary);
    border-right: solid 1px var(--border-primary);
    border-bottom: solid 1px var(--border-primary);
  }
}
</style>
<style lang='scss' scoped>
@import "~@/assets/styles/design-system";
.workflow {
  padding: rem(25);
  display: flex;
  flex-direction: column;
  &__header{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .add-workflow-title {
      margin-bottom: rem(20);
      color: var(--text-primary);
      font-family: $font-family-semibold;
      font-size: rem(22);
      font-weight: bold;
      line-height: rem(20);
      letter-spacing: 0;
      text-transform: capitalize;
    }
    .close-button {
      align-self: flex-end;
      margin-bottom: rem(20);
      &:hover {
        cursor: pointer;
        color: var(--brand-primary);
      }
    }
  }
  &__content {
    display: flex;
    flex-direction: column;
    .actions {
      display: flex;
      justify-content: flex-end;
    }

    .flow-chart-section {
      border-radius: $radius-sm;
      margin-bottom: rem(25);
      .work-flow-graph .graph__container {
        border-style: solid;
        border-width: 1px;
        border-color: var(--border-primary);
      }
    }

    .v-text-field {
      max-width: rem(350);
      margin-top: 0px !important;
      border-radius: $radius-sm;
      background-color: var(--bg-primary);
    }

    .divider {
      margin-top: rem(25);
      margin-left: rem(30);
      margin-right: rem(30);
    }

    textarea {
      border-radius: $radius-sm;
      background-color: var(--bg-primary);
      height: rem(100);
      margin-bottom: rem(30);
      padding: rem(8) rem(10) rem(10) rem(12);

      &:focus {
        outline: none !important;
        border: 1px solid var(--text-secondary);
      }
    }
    .input-description {
      min-width: 100%;
    }

    .cancel-button {
      box-sizing: border-box;
      height: rem(32);
      width: rem(86);
      border: 1px solid var(--brand-primary) !important;
      color: var(--brand-primary) !important;
      border-radius: $radius-sm;
      background-color: var(--bg-primary) !important;
      box-shadow: $shadow-sm !important;
      line-height: rem(16);
      text-align: center;
      margin-left: rem(8);
      margin-top: rem(15);
    }

    .save-button {
      height: rem(32);
      width: rem(150);
      border-radius: $radius-sm;
      background-color: var(--brand-primary) !important;
      box-shadow: $shadow-sm !important;
      color: var(--text-inverse) !important;
      font-size: rem(12);
      font-weight: 500;
      letter-spacing: rem(1.07);
      line-height: rem(16);
      text-align: center;
      margin-left: rem(8);
      margin-top: rem(15);
    }

    .field-label {
      color: var(--text-secondary);
      font-family: $font-family-medium;
      font-size: rem(12);
      line-height: rem(20);
      letter-spacing: 0;
      margin-top: rem(25);
      margin-bottom: rem(5);
      text-transform: uppercase;
    }

    .work-flow-diagram {
      display: flex;
      justify-content: center;
    }
  }
}
</style>
